import i18n from "i18next";
import { AavoMosaicTabItem } from "src/components/common/mosaic/types.ts";
import { DeliveryTransportsViewExtraTabsParams } from "src/tenantCustomizations/TenantCustomizations.ts";
import { SalvosTransportProjectActivitiesDataGrid } from "src/tenantCustomizations/tenants/salvos/delivery/SalvosTransportProjectActivitiesDataGrid.tsx";
import { CenteredTypography } from "src/components/common/CenteredTypography.tsx";

export const getSalvosDeliveryTransportsViewExtraTabs = ({
	deliveryTransport,
}: DeliveryTransportsViewExtraTabsParams): AavoMosaicTabItem[] => {
	return [
		{
			key: "delivery_transport_project_activities",
			type: "panel",
			title: i18n.t("activities"),
			content:
				deliveryTransport == null ?
					<CenteredTypography>{i18n.t("select_a_transport")}</CenteredTypography>
				:	<SalvosTransportProjectActivitiesDataGrid
						key={deliveryTransport.deliveryTransportId}
						deliveryTransportId={deliveryTransport.deliveryTransportId}
					/>,
		},
	];
};
